/**
 * Toast Notification Utility
 * Simple toast notification system
 */

/**
 * Show a toast notification
 * @param {string} message - Toast message
 * @param {string} type - Toast type ('success', 'error', 'info', 'warning')
 * @param {number} duration - Duration in milliseconds (default: 3000)
 */
export function showToast(message, type = 'info', duration = 3000) {
  const container = document.getElementById('toast-container');
  if (!container) {
    console.warn('Toast container not found');
    return;
  }

  const toast = document.createElement('div');
  toast.className = `toast toast-${type}`;
  toast.textContent = message;

  container.appendChild(toast);

  // Trigger animation
  requestAnimationFrame(() => {
    toast.classList.add('show');
  });

  // Remove after duration
  setTimeout(() => {
    toast.classList.remove('show');
    setTimeout(() => {
      if (toast.parentNode) {
        toast.parentNode.removeChild(toast);
      }
    }, 300); // Wait for fade out animation
  }, duration);
}

/**
 * Show success toast
 */
export function showSuccess(message, duration) {
  showToast(message, 'success', duration);
}

/**
 * Show error toast
 */
export function showError(message, duration = 5000) {
  showToast(message, 'error', duration);
}

/**
 * Show info toast
 */
export function showInfo(message, duration) {
  showToast(message, 'info', duration);
}

/**
 * Show warning toast
 */
export function showWarning(message, duration) {
  showToast(message, 'warning', duration);
}

